import { render, staticRenderFns } from "./UnitRelated.vue?vue&type=template&id=6315ddc4&scoped=true&"
import script from "./UnitRelated.vue?vue&type=script&lang=js&"
export * from "./UnitRelated.vue?vue&type=script&lang=js&"
import style0 from "./UnitRelated.vue?vue&type=style&index=0&id=6315ddc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6315ddc4",
  null
  
)

export default component.exports